import { SVGProps } from './types';

function LinkIcon(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.333 11.333H4.667a3.211 3.211 0 01-2.358-.975A3.216 3.216 0 011.333 8c0-.922.325-1.708.976-2.358a3.214 3.214 0 012.358-.975h2.666V6H4.667c-.556 0-1.028.195-1.417.583A1.929 1.929 0 002.667 8c0 .556.194 1.028.583 1.417.389.389.861.583 1.417.583h2.666v1.333zm-2-2.666V7.333h5.334v1.334H5.333zm3.334 2.666V10h2.666c.556 0 1.028-.194 1.417-.583.389-.39.583-.861.583-1.417 0-.555-.194-1.028-.583-1.417A1.929 1.929 0 0011.333 6H8.667V4.667h2.666c.922 0 1.709.325 2.359.975.65.65.975 1.436.975 2.358 0 .922-.326 1.708-.976 2.359-.65.65-1.436.975-2.358.974H8.667z"
      />
    </svg>
  );
}

export { LinkIcon };
